import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';

export default function access(initialState?: {
  authorizedResourceAccess?: AuthorizedResourceAccessMap;
  currentTenantIsAdmin?: boolean;
  permissionAccessStatus?: string;
}) {
  const admin = Boolean(initialState?.currentTenantIsAdmin);
  const resources =
    initialState?.permissionAccessStatus === 'loading' ||
    initialState?.permissionAccessStatus === 'error'
      ? {}
      : initialState?.authorizedResourceAccess;
  return {
    ...resources,
    permission: Boolean(resources?.permission),
    tenantAdmin: admin,
    modelSettings: Boolean(resources?.['model-settings']),
  };
}
